import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const MobileMenu = ({ isOpen, toggleMobileMenu }) => {
  const location = useLocation();

  // Update isActive to support subroutes
  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className={`vs-menu-wrapper ${isOpen ? "vs-body-visible" : ""}`}>
      <div className="vs-menu-area text-center">
        <button className="vs-menu-toggle" onClick={toggleMobileMenu}>
          <i className="fal fa-times"></i>
        </button>

        <div className="mobile-logo">
          <Link to="/">
            <img
              src="/img/logo2.jpg"
              alt="Travolo"
              style={{ height: "100px", width: "150px" }}
            />
          </Link>
        </div>

        <div className="vs-mobile-menu">
          <ul>
            <li>
              <NavLink
                exact="true"
                to="/"
                className={` ${isActive("/") ? "link-dom active" : ""}`}
                onClick={toggleMobileMenu}
              >
                Home
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/about"
                className={` ${isActive("/about") ? "link-dom active" : ""}`}
                onClick={toggleMobileMenu}
              >
                About Us
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/properties"
                className={` ${
                  isActive("/properties") ? "link-dom active" : ""
                }`}
                onClick={toggleMobileMenu}
              >
                Properties
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/gallery"
                className={` ${isActive("/gallery") ? "link-dom active" : ""}`}
                onClick={toggleMobileMenu}
              >
                Gallery
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/blogs"
                className={` ${isActive("/blogs") ? "link-dom active" : ""}`}
                onClick={toggleMobileMenu}
              >
                Blogs
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/contact"
                className={` ${isActive("/contact") ? "link-dom active" : ""}`}
                onClick={toggleMobileMenu}
              >
                Contact Us
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
